"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "Emirates Airlines",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/partner_logo_emirates_travel.png"
}, {
  name: "Marriott International",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/partner_logo_marriott_travel.png"
}, {
  name: "Lufthansa Group",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/partner_logo_lufthansa_travel.png"
}, {
  name: "Hilton Hotels",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/partner_logo_hilton_travel.png"
}, {
  name: "Qatar Airways",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/partner_logo_qatar_travel.png"
}, {
  name: "Hyatt Regency",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/partner_logo_hyatt_travel.png"
}];
export default function OurPrestigePartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}